/* eslint-disable import/prefer-default-export */
import { RISK_CLASIFICATION_ENG } from '../../constants';

export const convertToSpanish = (classification) => {
  const entry = Object.entries(RISK_CLASIFICATION_ENG)
    .find(([, value]) => value === classification);
  return entry ? entry[0] : null;
};
